import { render, staticRenderFns } from "./permissions_edit.vue?vue&type=template&id=45ea394e&"
import script from "./permissions_edit.vue?vue&type=script&lang=js&"
export * from "./permissions_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports